import { header, getLanguage } from "./header";

const changelog = header('restapi/api/v1/');

const setLanguage = () => {
    changelog.defaults.headers.common['Accept-Language'] = getLanguage()
}

const getAuth = () =>{
    let authorization = localStorage.getItem('auth')
    changelog.defaults.headers.common['Authorization'] =`Bearer ${authorization}` 
}

    const getLanguages = (lang) => {
        switch(lang){
            case 'RUS':
                return 'ru';
            case 'ENG':
                return 'en'
            case 'KAZ':
                return 'kk';
        }
    }

export const ChangelogService = {
    
    createChangelogArticle(selectedLanguage, parameters){
        setLanguage();
        getAuth();

        let params = {
            notificationType: parameters.notificationType, 
            content: parameters.content, 
            contentKk: parameters.contentKk, 
            contentEn: parameters.contentEn, 
            incidentTime: parameters.incidentTime, 
            releaseTag: parameters.releaseTag
        }

        return changelog.post('changelogs', {...params}).then(response => {
            return response.data;
        })
    },
    getChangelogs(locale, pageIndex = 0, pageSize = 20, sortField = "CREATED_AT", sortDirection = "DESC"){

        let lang = getLanguages(locale)
        getAuth();
        setLanguage();
        return changelog.get(`changelogs?pageIndex=${pageIndex}&pageSize=${pageSize}&sortField=${sortField}&sortDirection=${sortDirection}&locale=${lang}`).then(response => {
            return response.data;
        })
    },
    getChangelog(changeLogId, locale){
        getAuth();
        setLanguage();
        return changelog.get(`changelogs/${changeLogId}?locale=${locale}`).then(response => {
            return response.data;
        })
    },
    getChangelogsCount(){
        getAuth();
        setLanguage();
        return changelog.get(`/count`).then(response => {
            return response;
        })
    },
    updateChangelog(changeLogId, params){
        getAuth();
        setLanguage();
        return changelog.patch(`changelogs/${changeLogId}`, {...params}).then((response => {
            return response;
        }))
    },
    deleteChangelog(changeLogId){
        setLanguage();
        return changelog.delete(`changelogs/${changeLogId}`).then(response => {
            return response;
        })
    },
}